import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Printer } from './printer';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PrinterService {

  printersApi = environment.apiPath + '/printers';
  separator = '/';

  constructor(private http: HttpClient) { }

  getPrinters(): Observable<Printer[]> {
    return this.http.get<Printer[]>(this.printersApi);
  }

  getPrintersBy(printerNames: string[]): Observable<Printer[]> {
    console.log(printerNames);
    const url = this.printersApi + '?printerNames=' + printerNames;
    console.log(url);
    return this.http.get<Printer[]>(url);
  }

  createPrinter(printer: Printer): Observable<Printer> {
    return this.http.post<Printer>(this.printersApi, printer);
  }

  deletePrinter(printer: Printer): Observable<Printer> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }), body: printer
    };
    return this.http.delete<Printer>(this.printersApi, httpOptions);
  }

  pausePrinter(printerName: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/pause', null);
  }

  resumePrinter(printerName: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/resume', null);
  }

  enablePrinter(printerName: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/enable', null);
  }

  disablePrinter(printerName: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/disable', null);
  }

  printTestPage(printerName: string): Observable<any> {
    return this.http.post(this.printersApi + this.separator + printerName + '/print', null);
  }
}
